import React from 'react';
import { GiftCodeContainer, BalanceWrapper, BannerWrapper, StyledValueText, StyledInfoText, GiftCodeWrapper } from './styled';
import NotificationBanner from '../NotificationBanner/NotificationBanner';
import { parseString } from '@chegg/commerce-utils';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { getString } from '../../constants/Strings';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import CardLogo from '../CardLogo';
import { CardTypes } from '../../constants/PaymentTypes';
import { NotificationTypes } from '@chegg-ui/notification-banner';
import { getPaymentServerErrorText } from '../PaymentForm/helpers';
import { PaymentFormDataFields } from '../UserAddress/constants';
var GiftCode = function GiftCode() {
  var config = useAppSelector(configSelector);
  var yiftee = config.yiftee,
    priceSummary = config.priceSummary,
    paymentErrorModal = config.paymentErrorModal;
  if (!priceSummary) {
    return null;
  }
  var _ref = yiftee,
    balance = _ref.balance,
    yifteeCoveringFull = _ref.yifteeCoveringFull;
  var subtotal = priceSummary.subtotal;
  var renderSubtext = function renderSubtext(subtotal, balance) {
    if (!yifteeCoveringFull) {
      if (balance === 0) {
        return /*#__PURE__*/React.createElement(BannerWrapper, null, /*#__PURE__*/React.createElement(NotificationBanner, {
          message: getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.GIFTCARD_ZERO_BALANCE) || getString('APP.GIFTCARD.ZERO_BALANCE'),
          bannerType: NotificationTypes.Error
        }));
      }
      var diff = (subtotal - balance).toFixed(2);
      return /*#__PURE__*/React.createElement(BannerWrapper, null, /*#__PURE__*/React.createElement(NotificationBanner, {
        message: parseString(getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.GIFTCARD_INSUFFICIENT_BALANCE) || getString('APP.GIFTCARD.INSUFFICIENT_BALANCE'), {
          diff: diff
        }),
        bannerType: NotificationTypes.Error
      }));
    } else {
      return /*#__PURE__*/React.createElement(StyledInfoText, null, getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.GIFTCARD_SUFFICIENT_BALANCE) || getString('APP.GIFTCARD.SUFFICIENT_BALANCE'));
    }
  };
  return /*#__PURE__*/React.createElement(GiftCodeContainer, {
    "data-test": DataTestAttributes.GIFT_CODE
  }, /*#__PURE__*/React.createElement(GiftCodeWrapper, null, /*#__PURE__*/React.createElement(CardLogo, {
    cardType: CardTypes.GIFTCODE,
    valid: true,
    isMopContainer: false
  }), /*#__PURE__*/React.createElement(BalanceWrapper, null, /*#__PURE__*/React.createElement(StyledValueText, null, parseString(getPaymentServerErrorText(paymentErrorModal, PaymentFormDataFields.GIFTCARD_VALUE) || getString('APP.GIFTCARD.VALUE'), {
    giftValue: balance.toString()
  })))), renderSubtext(subtotal, balance));
};
export default /*#__PURE__*/React.memo(GiftCode);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/GiftCode/GiftCode.js
// module id = 1508
// module chunks = 11